import { z } from "zod";

export const getWebfleetResourcesQuerySchema = z.object({
	includeIntegrated: z
		.enum(["true", "false"])
		.optional()
		.transform((v) => v === "true"),
});

export type GetWebfleetResourcesQuery = z.infer<typeof getWebfleetResourcesQuerySchema>;
